import React from 'react';
import PropTypes from 'prop-types';

// material
import {
  Stack,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  FormControlLabel,
  Box
} from '@mui/material';
import { useTranslation } from '../../common/LocalizationProvider';

VolShareSideBarSettings.propTypes = {
  state: PropTypes.object.isRequired,
  setState: PropTypes.func.isRequired
};

export default function VolShareSideBarSettings({ state, setState }) {
  const t = useTranslation();

  return (
    <Box sx={{ mb: 10 }}>
      <Stack spacing={3} alignItems="center">
        <Stack direction="row" spacing={4}>
          <FormControl fullWidth>
            <FormLabel id="speed-radio-buttons-group-label">{t('LM_Speed')}</FormLabel>
            <RadioGroup
              aria-labelledby="speed-radio-buttons-group-label"
              name="speed-radio-buttons-group"
              value={state.uniteVitesse || ''}
              onChange={(event) => setState({ ...state, uniteVitesse: event.target.value })}
            >
              <FormControlLabel value="km/h" control={<Radio />} label="km/h" />
              <FormControlLabel value="kt" control={<Radio />} label="kt" />
            </RadioGroup>
          </FormControl>

          <FormControl fullWidth>
            <FormLabel id="altitude-radio-buttons-group-label">{t('FR_Graph_Altitude')}</FormLabel>
            <RadioGroup
              aria-labelledby="altitude-radio-buttons-group-label"
              name="altitude-radio-buttons-group"
              value={state.uniteAltitude || ''}
              onChange={(event) => setState({ ...state, uniteAltitude: event.target.value })}
            >
              <FormControlLabel value="m" control={<Radio />} label="m" />
              <FormControlLabel value="ft" control={<Radio />} label="ft" />
            </RadioGroup>
          </FormControl>

          <FormControl fullWidth>
            <FormLabel id="distance-radio-buttons-group-label">{t('RC_Distance')}</FormLabel>
            <RadioGroup
              aria-labelledby="distance-radio-buttons-group-label"
              defaultValue="female"
              name="distance-radio-buttons-group"
              value={state.uniteDistance || ''}
              onChange={(event) => setState({ ...state, uniteDistance: event.target.value })}
            >
              <FormControlLabel value="km" control={<Radio />} label="km" />
              <FormControlLabel value="mille" control={<Radio />} label="NM" />
            </RadioGroup>
          </FormControl>
        </Stack>
      </Stack>
    </Box>
  );
}
